export const CUSTOMER_CALCULATED_RATING_REF_ENTITY = 'indskr_customercalculatedrating';
export const CUSTOMER_CALCULATED_RATING_ID_ATTRIBUTE_NAME = 'indskr_customercalculatedratingid';
export const CUSTOMER_CALCULATED_RATING_POSITION_GROUP_ATTRIBUTE_NAME = 'indskr_positiongroup';
export const CUSTOMER_CALCULATED_RATING_CALC_RATING_ATTRIBUTE_NAME = 'indskr_calculatedrating';
